var aktid = 0;

$( document ).ready(function() {	
	var img = $( 'ul.single-collection li:nth-child(1)' ).data('img');
	var url = $( 'ul.single-collection li:nth-child(1)' ).data('url');
	var id = $( 'ul.single-collection li:nth-child(1)' ).attr('id');
	aktid = id;
	showCollectionImage(img, id);
	
	$( document ).on('click', '.next', function(){
		showNextImage();
	});
	
	$( document ).on('click', '.previous', function(){		
		showPrevImage();
	});
});
	
function showCollectionImage(img, url, id){
	
	
	
	if( $('.previous').length < 1 ){
		$( '.container' ).append( '<div class="previous"></div><div class="next"></div>' );
	}
	$( 'body' ).css( 'background-image', 'url( http:'+ img +')' );
	$( 'body' ).css( 'background-size', 'cover' );
}

function showNextImage(){
	var newid = $( 'li#'+aktid ).next().attr('id');
		
	if( $( 'li#'+newid ).length == 0 ){
		newid = $( 'ul.single-collection li:first-child' ).attr('id');
	}
	
	showCollectionImage( $( 'li#'+newid ).data('img'), newid );
	aktid = newid;
}

function showPrevImage(){
	var newid = $( 'li#'+aktid ).prev().attr('id');
	
	if( $( 'li#'+newid ).length == 0 ){
		newid = $( 'ul.single-collection li:last-child' ).attr('id');
	}
	
	showCollectionImage( $( 'li#'+newid ).data('img'), newid );
	aktid = newid;
}